import React from 'react'
import { LoginComp } from '../../../components/main/login/LoginComp'

export const Login = () => {
  return (
    <div>
      <LoginComp/>
    </div>
  )
}
